import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Input} from '../'
import analytics from '@cred/react-analytics/hoc/emitOnBlur'
import {FormField} from '@cred/react-form-field'
import NumberFormat from 'react-number-format'
import {Label} from '@cred/react-label'
import styles from './themes/default/styles.module.scss'

class MoneyInput extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    id: PropTypes.string,
    placeholder: PropTypes.string,
    icon: PropTypes.bool,
    validate: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.func)])
  }

  static defaultProps = {label: ''}

  static displayName = 'MoneyInput'

  render() {
    const {className, name, label, validate, placeholder, ...props} = this.props

    return (
      <div className={className}>
        <Input type="text" name={`${name}`} component={inputWithAnalytics} validate={validate} placeholder={placeholder} label={label} {...props}/>
      </div>
    )
  }
}

const inputComponent = ({input, label, meta, id, getInputRef, decimalScale = 0, theme, placeholder = '$', icon = true}) =>
  <FormField status={meta} error={meta.error} value={input.value} label={label} icon={icon} theme={theme}>
    <div className={styles.inputContainer}>
      <div className={styles.dollarSign}><i className="cred-icon icon-money-dollar"></i></div>
      <div className={styles.input}>
        <NumberFormat
          isAllowed={({floatValue}) => floatValue === undefined || floatValue <= 9999999}
          thousandSeparator={true}
          prefix="$"
          decimalScale={decimalScale}
          allowNegative={false}
          type="tel"
          placeholder={placeholder}
          maxLength="13"
          id={id || input.name}
          getInputRef={getInputRef}
          {...input}
        />
      </div>
      <Label className={styles.label} htmlFor={id || input.name}>{label}</Label>
    </div>
  </FormField>,
  inputWithAnalytics = analytics(inputComponent)

export {MoneyInput as MoneyInputNoHoc, inputComponent}

export default MoneyInput
